import { CMSResource } from "app/resources/cmsresource";
import { FooterLinksTypeResource } from "app/models/FooterLinksTypeResource";

export class FooterLinksTypeListResource extends CMSResource {

    footerLinksTypeListResource: FooterLinksTypeResource[];
}